import { IRole } from "../user";

export type PermissionValueType =
  | UserPermissionType.EDITOR
  | UserPermissionType.VIEWER
  | UserPermissionType.NO_ACCESS
  | UserPermissionType.ADMIN;

export interface IUserManage {
  id: number | null;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  phone_number: string;
  investors: IUserManageInvestmentEntity[];
  // teams: string[];
  // groups: string[];
  // investment_entities: string[];
  note: string | null;
  role: IRole;
  invite_user: boolean | null;
  permissions?: Record<string, PermissionValueType>;
}

export interface IUserManageInvestmentEntity {
  id: number;
  name: string;
}

export interface IUserManagePermission {
  permission_type: string;
  access: PermissionValueType;
}

export interface IPermissionItem {
  key: string;
  title: string;
}

export interface IUserManageData {
  id?: number | null;
  first_name: string;
  last_name: string;
  note: string | null;
  phone_number: string;
  email: string;
  role_id: number;
  invite_user: boolean | null;
  permissions?: IUserManagePermission[];
  investor_ids?: number[];
}

// export interface IUpdateUserManage extends ICreateUserManage {
// }

export interface IUsersManageQueries {
  search?: string;
  role_id?: number[];
  group_id?: number[];
  per_page?: number;
  page?: number;
}

export type ClientType = "Individual" | "Family" | "Legal entity";

export interface IClientFilters {
  search?: string;
  type?: ClientType | "";
  rm?: string | "";
  page?: number;
  per_page?: number;
}

export interface IClient {
  id: number;
  name: string;
  type: ClientType | null;
  rm: string | null;
  entity_count: number;
}

export enum ClientTypeEnum {
  INDIVIDUAL = "Individual",
  FAMILY = "Family",
  LEGAL_ENTITY = "Legal entity"
}

export interface CreateClientPayload {
  name: string;
  type?: string | null;
  relationship_manager?: string | null;
  country?: string | null;
  primary_currency?: string | null;
}

export interface InvestEntity {
  id: number;
  deal_name: string;
  parent_entities: string[];
  subordinated_entities: string[];
  users: Array<{
    profile_photo_url: string;
    role_id: number;
    account_id: number;
    full_name: string;
    id: number;
  }>;
}

// export interface IUserManage extends Omit<IUsersManage, "role_name"> {
//   role: IRole;
//   permissions: IUserManagePermission[];
// }

export interface IUserManageGroup {
  id: number;
  name: string;
}

export interface ManageTeam {
  id: number;
  team_name: string;
  users: Array<{
    id: number;
    profile_photo_url: string;
    role_id: number;
    account_id: number;
    full_name: string;
    email: string;
  }>;
  deals: Array<{
    id: number;
    deal_name: string;
    parent_deal: string;
    sub_deals: string[];
    other_teams: string[];
  }>;
  note: string;
}

export enum UserPermissionType {
  NO_ACCESS = "no_access",
  EDITOR = "editor",
  VIEWER = "viewer",
  ADMIN = "admin"
}
